import { Component }             from '@angular/core';
import { NavController }         from 'ionic-angular';
import { LoadingController }     from 'ionic-angular';
import { PopoverController }     from 'ionic-angular';
import { dmHotel }               from './xv-hotel';
import { AppMenuViewModel }      from '../../app/xv-menu';
import { SignInViewModel }       from './xv-sign-in';
import { WelcomePage }           from '../welcome/welcome';
import { EnablePage }            from '../enable/enable';
import { SpotlightPage }         from '../spotlight/spotlight';
import { PMSPage }               from '../pms/pms';
import { HousekeepingPage }      from '../housekeeping/housekeeping';
import { SelectLangPopoverPage } from './select-lang-popover';
import { MLText, mlBroker }      from '../../services/MLText';
import { AppDataBroker }         from '../../services/AppData';
import { dmLoading }             from '../loading/loading';
import { RQApp, RQService }      from '../../RQuery/RQuery';

@Component({
    selector:    'page-sign-in',
    templateUrl: 'sign-in.html'
})
export class SignInPage {
    SignIn:          SignInViewModel;

    NewLoading:      (pMessage: string) => dmLoading;
    ShowSelectLang:  (myEvent: any)     => void;
    GoToWelcome:     ()                 => void;

    IsAutoLogin:     boolean;
    IsEnableRequest: boolean;
    IsPMSRequest:    boolean;
    IsCTMRequest:    boolean;

    EnableUser:      string;
    EnableCred:      string;

    app:             mlBroker;

    constructor(
         public navCtrl:       NavController
        ,public loadingCtrl:   LoadingController
        ,public popoverCtrl:   PopoverController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        console.log('initialise sign-in');

        this.IsEnableRequest = false;
        this.IsPMSRequest    = false;
        this.IsCTMRequest    = true;
        this.EnableUser      = '';
        this.EnableCred      = '';

        this.app = this.mlText.GetBroker('BookingEngineAppTexts');

        let params = new URLSearchParams(window.location.search.substr(1));

        let paramEnableRates = params.get('EnableRates');
        let paramEnablePMS   = params.get('EnablePMS');
        let paramEnableUser  = params.get('EnableUser');
        let paramEnableCred  = params.get('EnableCred');

        let enableRates: number = 0;
        let enablePMS:   number = 0;
        let enableUser:  string = '';
        let enableCred:  string = '';

        if (paramEnableRates) {
            enableRates = Number(paramEnableRates);
        }

        if (paramEnablePMS) {
            enablePMS   = Number(paramEnablePMS);
        }

        if (paramEnableUser) {
            enableUser  = paramEnableUser;
        }

        if (paramEnableCred) {
            enableCred  = paramEnableCred;
        }

        this.IsEnableRequest = (enableRates > 0);
        this.IsPMSRequest    = (enablePMS   > 0);
        this.IsAutoLogin     = (enableUser != '');
        this.EnableUser      = enableUser;
        this.EnableCred      = enableCred;

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.GoToWelcome    = ()             => { return; };
        this.ShowSelectLang = (myEvent: any) => { return; };

        let hotel = appDataBroker.GetAppData()          as dmHotel;
        let menu  = appDataBroker.GetAppMenuViewModel() as AppMenuViewModel;

        hotel.IsAutoLogin     = this.IsAutoLogin;
        hotel.IsEnableRequest = this.IsEnableRequest;

        this.IsCTMRequest     = hotel.IsViaNearby;

        this.SignIn = new SignInViewModel(
             mlText
            ,hotel
            ,menu
            ,this.GoToWelcome
            ,this.ShowSelectLang
        );

        this.GoToWelcome = () => {
            menu.initialise();

            this.IsCTMRequest = hotel.IsViaNearby;

            this.SignIn.HotelNeedsDiscountSettingsAction(
                (pNeedAction: boolean) => {
                    if (this.IsCTMRequest) {
                        if (
                            this.mlText.IsViewLangLoaded(
                                 'HotelAreaHousekeeping'
                                ,this.mlText.GetLangID()
                            )
                        ) {
                            this.navCtrl.setRoot(HousekeepingPage);

                            menu.Menu.NavToHousekeeping();

                            return;
                        }
                    } else if (this.IsPMSRequest) {
                        if (
                            this.mlText.IsViewLangLoaded(
                                 'HotelAreaPMS'
                                ,this.mlText.GetLangID()
                            )
                        ) {
                            this.navCtrl.setRoot(PMSPage);

                            menu.Menu.NavToPMS();

                            return;
                        }
                    } else if (this.IsEnableRequest || (pNeedAction && !this.IsAutoLogin)) {
                        if (
                            this.mlText.IsViewLangLoaded(
                                 'HotelAreaSpotlight'
                                ,this.mlText.GetLangID()
                            )
                        ) {
                            this.navCtrl.setRoot(SpotlightPage);

                            menu.Menu.NavToEnable();

                            return;
                        }
                    } else {
                        if (
                            this.mlText.IsViewLangLoaded(
                                 'HotelAreaWelcome'
                                ,this.mlText.GetLangID()
                            )
                        ) {
                            this.navCtrl.setRoot(WelcomePage);

                            menu.Menu.NavToWelcome();

                            return;
                        }
                    }

                    let loading: dmLoading = this.NewLoading(
                        this.app.Text('LoadingMark' ,'Loading...')
                    );

                    loading.Show(() => {
                        if (this.IsCTMRequest) {
                            this.mlText.LoadView(this.mlText.GetLangID(), 'HotelAreaHousekeeping', () => {
                                loading.Dismiss();

                                this.navCtrl.setRoot(HousekeepingPage);

                                menu.Menu.NavToHousekeeping();

                                return;
                            });
                        } else if (this.IsPMSRequest) {
                            this.mlText.LoadView(this.mlText.GetLangID(), 'HotelAreaPMS', () => {
                                loading.Dismiss();

                                this.navCtrl.setRoot(PMSPage);

                                menu.Menu.NavToPMS();

                                return;
                            });
                        } else if (this.IsEnableRequest || (pNeedAction && !this.IsAutoLogin)) {
                            this.mlText.LoadView(this.mlText.GetLangID(), 'HotelAreaSpotlight', () => {
                                loading.Dismiss();

                                this.navCtrl.setRoot(SpotlightPage);

                                menu.Menu.NavToEnable();

                                return;
                            });
                        } else {
                            this.mlText.LoadView(this.mlText.GetLangID() ,'HotelAreaWelcome' ,() => {
                                loading.Dismiss();
                                
                                this.navCtrl.setRoot(WelcomePage);

                                menu.Menu.NavToWelcome();

                                return;
                            });
                        }
                    });
                }
            );
        };

        this.ShowSelectLang = (myEvent: any) => {
            let popover = this.popoverCtrl.create(
                 SelectLangPopoverPage
                ,{ signIn: this.SignIn }
            );

            popover.onDidDismiss((data: any, role: string) => {
                if (data == null) { return; }

                let selectLang = data as () => void;

                selectLang();
            });

            popover.present({
                ev: myEvent
            });
        };

        this.SignIn.GotToWelcome   = this.GoToWelcome;
        this.SignIn.ShowSelectLang = this.ShowSelectLang;

        if (this.IsAutoLogin) {
            console.log('auto login detected - performing sign in');

            RQApp.SetSession('NO_API_KEY', '');

            this.SignIn.Hotel.SignIn(
                 this.EnableUser
                ,this.EnableCred
                ,(pAuthResult: RQService.Auth.RQLoginRow) => {
                    if (pAuthResult.IsAuthenticated) {
                        console.log('sign in cleared');

                        this.GoToWelcome();
                    } else {
                        console.log('sign in unsuccessful');
                    }
                }
            );
        } else {
            this.SignIn.Hotel.CheckSession((pIsAuthenticated) => {
                if (pIsAuthenticated) { this.GoToWelcome(); }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/sign-in/sign-in.ts